module.exports = __webpack_public_path__ + "static/media/mid2.867bf5d7.webm";